//Used In               : \ui\src\components\common\Privacy
//Business Justification: To keep track of the policy versions accepted by the end users
export const OPTUM_MATCH_POLICY_VERSION = '1.2'
export const SURVEY_FREE_CHARACTER_LIMIT = 250
export const TIME_OUT_IN_MINUTES = 20
export const NUDGE_BEFORE_TIMEOUT_IN_MINUTES = 5
// Admin-specific timeout constants
export const ADMIN_TIME_OUT_IN_MINUTES = 30
export const ADMIN_NUDGE_BEFORE_TIMEOUT_IN_MINUTES = 5
export const PATIENT_MINIMUM_ANSWER_COUNT = 5
export const OBGYN_MINIMUM_ANSWER_COUNT = 9
// Survey business IDs used to identify specialty-specific surveys in the DB
export const SPECIALTY_PRIMARY_CARE = 's1'
export const SPECIALTY_OBGYN = 's2'

//enabling OB-GYN functionality is currently on hold, but keeping the constant for when we decide to enable it in the future
export const ENABLE_OBGYN = true

export const ENGLISH = 'english'

export const BACKGROUND_IDENTITIES = 'Background and identities'
export const STARTED = 'Started'

export const CONTACT_FORM_STATES_OF_US = [
  'Alabama',
  'Alaska',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'Florida',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Pennsylvania',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming',
  'International',
  'Other',
]
export const CONTACT_FORM_USER_ROLES = [
  'Clinician',
  'Executive/Administrative Staff',
  'Payer',
  'Other',
]
export const CONTACT_FORM_CLINICIAN_COUNT = [
  'Less than 20',
  '21-50',
  '51-100',
  '100+',
]

//Toast Messages IDs
export const IDLE_STATE_INACTIVITY_MESSAGE = 'idle-state-inactivity-message'
export const IDLE_STATE_LOGGED_OUT_MESSAGE = 'idle-state-logged-out-message'
// Admin-specific toast message IDs
export const ADMIN_IDLE_STATE_INACTIVITY_MESSAGE =
  'admin-idle-state-inactivity-message'
export const ADMIN_IDLE_STATE_LOGGED_OUT_MESSAGE =
  'admin-idle-state-logged-out-message'
export const SURVEY_REVIEW_SUBMIT_VALIDATION_MESSAGE =
  'survey-review-submit-validation-message'
export const SURVEY_REVIEW_INCOMPLETE_SUBMIT_VALIDATION_MESSAGE =
  'survey-review-incomplete-submit-validation-message'
export const PROVIDER_PROFILE_CALLBACK_SUBMISSION_RESPONSE_ERROR =
  'provider-profile-callback-submission-response-error'
export const PROVIDER_PROFILE_CALLBACK_SUBMISSION_GEN_ERROR =
  'provider-profile-callback-submission-gen-error'
export const PROVIDER_PROFILE_CALLBACK_MISSING_PHONE_NUMBER_ERROR =
  'provider-profile-callback-missing-phone-number-error'
export const PROVIDER_PROFILE_CALLBACK_SUCCESS_MESSAGE =
  'provider-profile-callback-success-message'
export const NOT_AVAILABLE_FORM_SUBMISSION_ERROR =
  'not-available-form-submission-error'
export const NOT_AVAILABLE_FORM_SUBMISSION_SUCCESS_MESSAGE =
  'not-available-form-submission-success-message'
export const NOT_AVAILABLE_FORM_SUBMISSION_SAVE_ERROR =
  'not-available-form-submission-save-error'
export const ABOUT_ME_PATIENT_EDIT_ERROR = 'about-me-patient-edit-error'
export const PATIENT_FILTER_SAVE_ERROR = 'patient-filter-save-error'
export const CONTACT_US_PERSONA_SELECTION = 'contact-form-persona-selection'
export const CONTACT_US_USER_CLOSE = 'contact-form-user-close'
export const CONTACT_FORM_MISSING_ENTRIES_ERROR =
  'contact-form-missing-entries-error'
export const CONTACT_FORM_SUCCESS_MESSAGE = 'contact-form-success-message'
export const CONTACT_FORM_SUBMIT_ERROR_MESSAGE =
  'contact-form-submit-error-message'
export const DEACTIVATE_PROFILE_SUBMISSION_ERROR_MESSAGE =
  'deactivate-profile-submission-error-message'
export const PROVIDER_PROFILE_EDIT_ERROR_MESSAGE =
  'provider-profile-edit-error-message'
export const PATIENT_NOT_AVAILABLE_FORM_SUBMISSION_ERROR =
  'patient-not-available-form-submission-error'
export const PATIENT_NOT_AVAILABLE_FORM_SUBMISSION_SUCCESS_MESSAGE =
  'patient-not-available-form-submission-success-message'
export const PATIENT_NOT_AVAILABLE_FORM_SUBMISSION_SAVE_ERROR =
  'patient-not-available-form-submission-save-error'
export const PATIENT_ACTION_REMOVE_PROVIDER_SUCCESS =
  'patient-action-remove-provider-success'
export const PATIENT_ACTION_SAVE_PROVIDER_SUCCESS =
  'patient-action-save-provider-success'
export const PATIENT_ACTION_SAVE_PROVIDER_ERROR_MESSAGE =
  'patient-action-save-provider-error-message'
export const PATIENT_ACTION_SAVE_FOR_LATER_ERROR_MESSAGE =
  'patient-action-save-for-later-error-message'
export const PATIENT_ACTION_RESTORE_PROVIDER_SUCCESS =
  'patient-action-restore-provider-success'
export const PATIENT_ACTION_RESTORE_PROVIDER_ERROR_MESSAGE =
  'patient-action-restore-provider-error-message'
export const PATIENT_ACTION_GENERAL_ERROR_MESSAGE =
  'patient-action-general-error-message'
export const PRIVACY_POLICY_CONSENT_VALIDATION_MESSAGE =
  'Your agreement is required to continue'
export const NOTIFICATION_CREATE_SUCCESS_MESSAGE =
  'notification—create-success-message'
export const NOTIFICATION_EDIT_SUCCESS_MESSAGE =
  'notification-edit-success-message'
export const NOTIFICATION_DELETE_SUCCESS_MESSAGE =
  'notification-delete-success-message'
export const NOTIFICATION_CREATE_ERROR_MESSAGE =
  'notification—create-error-message'
export const NOTIFICATION_EDIT_ERROR_MESSAGE = 'notification-edit-error-message'
export const NOTIFICATION_DELETE_ERROR_MESSAGE =
  'notification-delete-error-message'
export const NOTIFICATION_GET_ERROR_MESSAGE = 'notification-get-error-message'
export const NOTIFICATION_VALIDATION_ERROR_MESSAGE =
  'notification-validation-error-message'
export const ENABLE_OB_GYN_FUNATIONALITY = false
export const CALL_TO_SCHEDULE_REQUEST_FEEDBACK_SUCCESS =
  'provider-profile-call-to-schedule-feedback-success-message'
export const CALL_TO_SCHEDULE_REQUEST_FEEDBACK_ERROR =
  'provider-profile-call-to-schedule-feedback-error-message'
export const REPLACEMENT_MAP_VALUES_JSON = {
  'ADHD care': 'ADHD diagnosis and care',
  'Family planning': 'Birth control',
  'Sports participation related': 'Sports participation related services',
  "Worker's compensation or disability claims related":
    "Worker's compensation or disability claims related services",
  'Travel and immigration related': 'Travel and immigration related services',
  'Alternative diet': 'Hands-on guidance for new diets',
  DASH: 'DASH diet',
  'Gluten-free': 'Gluten-free diet',
  Keto: 'Keto diet',
  Paleo: 'Paleo diet',
  Vegan: 'Vegan diet',
  Vegetarian: 'Vegetarian diet',
  'Weight Watchers': 'Weight loss diet',
  'Alternative Medicine': 'Natural and integrative medicine',
}

export const LOCALHOST_NAME = 'localhost'
export const OPTUM_MATCH_HOST_NAME = 'optummatch.com'
